// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8429e574","239":"dfdb0d71","732":"0eb8fd42"}[chunkId] + ".chunk.js";
};